import React from 'react';
import styled, { css } from 'styled-components';

const IconWrapper = styled.div`
  margin-bottom: 15px;

  img, svg {
    width: 150px;
    height: auto;
    color: rgba(0,0,0,0.22);
  }
`;

const Text = styled.div`
  font-size: 35px;
`;


const StyledAlertScreen = styled.div`
  width: 100%;
  height: 100%;
  padding: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  line-height: 1;
  color: rgba(0,0,0,0.22);
  background: #fff;
  z-index: 1;

  ${props => props.type === 'warning' && css`
    color: rgba(255,204,0.22);

    ${IconWrapper} {
      img, svg {
        color: rgba(255,204,0.22);
      }
    }
  `};
`;

const AlertScreen = ({
  icon,
  children,
  type,
}) => {
  return (
    <StyledAlertScreen type={type}>
      <IconWrapper>
        {icon}
      </IconWrapper>

      <Text>{children}</Text>
    </StyledAlertScreen>
  );
};

export default AlertScreen;



// WEBPACK FOOTER //
// ./src/components/IterioApp/Users/Details/AlertScreen/AlertScreen.jsx